import { rupeesToPaise } from './money.js';

/** Today's date in India as yyyy-mm-dd, for date fields that start on today. */
export function istDateInput(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

/** True when the brokerage split adds up to the total, both sides in rupees as typed. */
export function splitAddsUp(total: string, tenant: string, owner: string): boolean {
  const t = rupeesToPaise(total);
  const a = rupeesToPaise(tenant);
  const b = rupeesToPaise(owner);
  return t !== null && a !== null && b !== null && a + b === t;
}

/** The owner's share when the tenant's is typed, so the two always add up to the total. */
export function otherShare(total: string, share: string): string {
  const t = rupeesToPaise(total);
  const s = rupeesToPaise(share);
  if (t === null || s === null || s > t) return '';
  const rest = t - s;
  return rest % 100 === 0 ? String(rest / 100) : (rest / 100).toFixed(2);
}
